// extracted by mini-css-extract-plugin
export default {"panel":"LoginSessionPanel_panel__KFUWL","user_menu":"LoginSessionPanel_user_menu__THzDs","no_access":"LoginSessionPanel_no_access__6EHAd","button":"LoginSessionPanel_button__TexBN"};